import {all} from '@redux-saga/core/effects';
import legalAcceptanceSaga from 'Core/sagas/legalAcceptanceSaga';
import searchSaga from 'Core/sagas/searchSaga';

export default function*() {
  yield all([searchSaga(), legalAcceptanceSaga()]);
}
